'use strict';

// Rework of original pasteHtmlAtCaret that did some cleanup on the text to paste.
// Current choice is to intercept ALL paste events and get only the text + replace newlines with <br> tags
// IMPORTANT: This does make the pasted text anywhere lose it's styling. When not intercepting paste we're going to have a lot more "arbitrary" html though.
// cleanupPastedText can also be used outside of paste event when willing to trigger this manually with given text
// Possible Upgrades/Changes:
//      - Instead of getData('text/plain') have something more advanced to be able to keep some styling.
//      - Instead of intercepting ALL paste events on the current document, might want to be more precise with the jquery element selection
$(document).on('paste', '[contenteditable]', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();

    var clipboardText = (e.originalEvent || e).clipboardData.getData('text/plain');
    clipboardText = encodeNewlines(clipboardText);

    // Checking if the pasted text is an html element, if so interpret it as regular text
    // NOTE: As long as this text is never interpreted as actual HTML we're fine, but at some point I think this might allow XSS...
    const containsHtml = clipboardText.match(/<.*?>.*?<\/.*?>/);
    pasteAtCaret(clipboardText, !containsHtml);
});

window.encodeNewlines = function (text) {
    text = text.replace(/\n/g, '<br>');
    return text;
}

window.pasteAtCaret = function (text, asHtml) {
    const selection = window.getSelection();
    if (!selection.rangeCount) return false;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    var el = document.createElement("div");

    if (asHtml)
        el.innerHTML = text;
    else
        el.innerText = text;

    var frag = document.createDocumentFragment(), node, lastNode;
    while ((node = el.firstChild)) {
        lastNode = frag.appendChild(node);
    }
    range.insertNode(frag);
}

$(function () {
    $('#loading').hide();
    $('#emptyPage').hide();
    $('#ajaxSmallLoader').hide();

    $('div#content p#closeActiveFile').hide();

    $('div#appLayout a[href="#"]').on('click', function (e) {
        e.preventDefault();
    });

    // IMPORTANT: Ridiculous... I'm fairly sure this is only done to make the saving of the file possible. Otherwise you would lose the state of the inputs (because the value attribute is not set by default)
    $('body').on('keyup', 'div#contentView input:not(.ui-autocomplete-input)', function () {
        $(this).attr('value', $(this).val());
    });
    $('body').on('keyup', 'div#contentView textarea', function () {
        $(this).attr('value', $(this).val());
    });
    $('body').on('change', 'div#contentView select', function () {
        $(this).attr('value', $(this).val());
    });

    $(window).resize(function (e) {
        setTimeout(function () {
            if ($('div#subContent').find('div#submitBottom').length > 0) {
                $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());
            }
        }, 100);
    });

    // NOTE: Be mindful of this... This breaks all regular enter keypresses for all elements in the DOM! (for example: this broke adding newlines in the report email textarea)
    // For the future: I'd rather do this per dialog, so that it's an obvious choice, rather than do it on all dialogs without anyone knowing
    $('body').on('keypress', '.dialog', function (e) {
        if ($(':focus').attr('id') === 'txtContent') return; // Needed this exception to allow newlines in the report email textarea...

        if (e.which == 13) {
            var btn = $(this).find('button.saveAndClose');
            btn.trigger("click");
            return false;
        }
    });

    $('body').on('keypress', 'input.auto', function (e) {
        if (e.keyCode == 13) {
            return false;
        }
    });

    $('body').on('keyup', 'input.autoWithMenu', function (e) {
        if ($.trim($(this).val()) == "") {
            $(this).css('border-color', '#DADADA');
            $(this).parent().find('.idForAutoWithMenu').val("0");
        }
    });

    $('body').on('submit', function (e) {
        $(this).find('div#submitBottom input').attr("disabled", "disabled");
        $('#loading').show();


    });

    // Only used for the dataTables pagination
    $('body').on('keyup', function (e) {
        if (e.keyCode == 37) { // left
            $('div.dataTables_paginate a.previous').trigger('click');
            return false;
        }
        else if (e.keyCode == 39) { // right
            $('div.dataTables_paginate a.next').trigger('click');
            return false;
        }
    });

    $('body').on('mouseover', '.infoIcon', function (e) {
        e.stopImmediatePropagation();
        var infoHoverPopup = $(this).find('.infoHoverPopup');
        if (!$(infoHoverPopup).is(':visible')) {
            infoHoverPopup.show();
        }
    });

    $('body').on('mouseout', '.infoIcon', function (e) {
        $(this).parent().find('.infoHoverPopup').hide();
    });

    $.ajaxSetup({
        global: true
    });
});

window.message_broadcast = function (command, data) {
    const message = {
        command: command,
        data: data
    }
    localStorage.setItem('row1Message', JSON.stringify(message));
    localStorage.removeItem('row1Message');
}

window.message_receive = function (ev) {
    if (ev != null && typeof (ev) !== "undefined") {

        if (ev.originalEvent.key !== 'row2Message') {
            return; // ignore other keys
        }

        const message = JSON.parse(ev.originalEvent.newValue);
        localStorage.removeItem('row2Message');
        if (!message) {
            return; // ignore empty msg or msg reset
        }

        if (message.command === "openOrder") {
            useFilingCabinet('/Orders/Detail/' + message.data.id + '?Edit=true');
        }
        else if (message.command === "openPatient") {
            useFilingCabinet('/Patients/Detail/' + message.data.id);
        }
        else if (message.command === "row2Ready") {
            sendPendingRow1Messages();
        }
        else if (message.command === "agendaReady") {
            sendPendingRow1AgendaMessages();
        }
    }
}

window.sendPendingRow1Messages = function () {
    if (localStorage.getItem('row1PendingMessage') != null) {
        const pendingMessage = localStorage.getItem('row1PendingMessage');
        localStorage.removeItem('row1PendingMessage');
        localStorage.setItem('row1Message', pendingMessage);
    }
}

window.sendPendingRow1AgendaMessages = function () {
    if (localStorage.getItem('row1PendingAgendaMessage') != null) {
        const pendingMessage = localStorage.getItem('row1PendingAgendaMessage');
        localStorage.removeItem('row1PendingAgendaMessage');
        localStorage.setItem('row1Message', pendingMessage);
    }
}

window.setPendingMessage = function (command, data, agenda) {
    const message = {
        command: command,
        data: data
    }
    if (agenda) {
        localStorage.removeItem('row1PendingAgendaMessage');
        localStorage.setItem('row1PendingAgendaMessage', JSON.stringify(message));
        return;
    }
    localStorage.removeItem('row1PendingMessage');
    localStorage.setItem('row1PendingMessage', JSON.stringify(message));
}

$(window).on('storage', message_receive);

window.showErrorPage = function (arg) {
    $('div#contentView').load('/legacy/Error');
    $('#loading').hide();
    $('#emptyPage').hide();
    closeActiveFile(false)
        .done(function () {
            var resReq = getFilingCabinet().done(function () {
                $('div#divFilingCabinet').html(resReq.responseText);


            });
        });
};

window.EnableAfterSubmit = function (e) {
    $('#loading').hide();
    $('body').find('div#submitBottom input').removeAttr("disabled");
};

window.SetActiveReportsIFrame = function (target, orderID, reportContent, reportID, forPartial) {
    if (!orderID) return;
    reportContent = reportContent.replace(/"/g, "&quot;");
    const form = $('<form action="/legacy/Reports/PreviewReport" id="ARiFrameForm" target="ARiFrame" method="POST"><input type="text" name="OrderID" id="OrderID" value="' + orderID + '"><input type="text" name="ReportContent" id="ReportContent" value="' + reportContent + '"><input type="text" name="Report_UID" id="Report_UID" value="' + reportID + '"><input type="text" name="ForPartial" id="ForPartial" value="' + forPartial + '"><input type="submit" value="POST"></form>');
    $('body').append(form);
    const iFrame = '<iframe src="/legacy/Reports/PreviewReport" name="ARiFrame" style="width: 100%; min-height: 1200px;"></iframe>';
    $('#' + target).html(iFrame);
    form.submit();
    form.remove();
    EnableAfterSubmit();
};

window.openNewAndRemoveActiveFile = function (link, prior, ignoreLocks = false) {
    clearRefreshTimeout();
    window.filingCabinetRemoveActive(ignoreLocks)
        .then(() => {
            window.useFilingCabinet(link);
        });
};

// This array is used to keep track of auto-refreshing tables on pages that need/use it
window.timeouts = [];
window.clearRefreshTimeout = () => {
    for (let i = 0; i < timeouts.length; i++)
        clearTimeout(timeouts[i]);
    //quick reset of the timer array you just cleared
    window.timeouts = [];
};

window.LockType = {
    Order: 1,
    Procedure: 2,
    Report: 3,
    Label: 4,
    Patient: 5,
    Company: 6,
    HealthInsurance: 7,
    Radiologist: 8,
    Technician: 9,
    Invoice: 10,
    Physician: 11,
    Links: 12,
    Urgency: 13,
    Visit: 14,
    Nomenclature: 15,
    OrderReport: 16
};

window.GetLockTypeBasedOnLink = function (fileLink, controller) {
    let type = '';
    if (fileLink.match(/Orders/))
        type = LockType.Order;
    if (fileLink.match(/LabelSettings/))
        type = LockType.Label;
    else if (fileLink.match(/Patients/))
        type = LockType.Patient;
    else if (fileLink.match(/Invoices/))
        type = LockType.Invoice;
    else if (fileLink.match(/Physician/))
        type = LockType.Physician;
    else if (fileLink.match(/Reports/)) {
        if (!controller || controller == LockType.Report)
            type = LockType.Report;
        else
            type = LockType.OrderReport;
    }
    else if (fileLink.match(/Companies/))
        type = LockType.Company;
    else if (fileLink.match(/HealthInsurances/))
        type = LockType.HealthInsurance;
    else if (fileLink.match(/InternalStaff\/.*Radiologist/))
        type = LockType.Radiologist;
    else if (fileLink.match(/InternalStaff\/.*Technician/))
        type = LockType.Technician;
    else if (fileLink.match(/Lists/))
        type = LockType.List;
    else if (fileLink.match(/Visits/))
        type = LockType.Visit;
    return type;
}

window.getNextOrderToBulkDictate = function (id, showWarning) {
    return $.ajax({
        type: 'POST',
        url: '/legacy/Reports/GetNextOrderToBulkDictate',
        data: {
            Order_UID: id,
            showWarning: showWarning
        }
    });
};

window.checkIfDictated = function (orderId, procedureString) {
    return $.ajax({
        type: 'POST',
        url: '/legacy/Reports/CheckIfDictated',
        dataType: 'json',
        data: {
            orderID: orderId,
            procedureString
        }
    });
}

window.getNextOrderToBulkValidate = function (orderId, reportId) {
    return $.ajax({
        type: 'POST',
        url: '/legacy/Reports/GetNextOrderToBulkValidate',
        data: {
            Order_UID: orderId,
            Report_UID: reportId
        }
    });
};

window.getNextBulkItem = function() {
    return $.ajax({
        type: 'POST',
        url: '/legacy/Reports/GetNextBulkItem'
    });
}

window.speechAlreadyClosed = false;

window.closeActiveFile = function (checkNext, isCloseAfterSave) {
    clearRefreshTimeout();
    var deferred = $.Deferred();
    if (!speechAlreadyClosed) {
        const closeG2Speech = $('div#contentView').find('span#hasG2Speech').html();
        if (closeG2Speech === "true") {
            closeActiveSpeech();
        }
    }

    if (checkNext) {
        window.filingCabinetRemoveActive(isCloseAfterSave)
            .then(() => {
                deferred.resolve();
            })
    }
    else {
        window.reloadActiveRazorView();
        deferred.resolve();
    }
    return deferred.promise();
};

// NOTE: Adapted "#lockableController" to hold the LockType ID we want to use. That is why calls to this function will still be the same as before (so naming doesn't match for now)
window.CheckLockBeforeSaving = function (type, recordID, formIDToSubmit, cb) {
    $.ajax({
        type: 'POST',
        url: '/legacy/Locks/CheckLockFileBeforeSaving',
        data: { LockType: type, RecordID: recordID },
        dataType: 'json',
        success:
            function (data) {
                if (!data.Done) return $('#divNotLockedDialog').dialog('open');
                if (cb) return cb(data, recordID, formIDToSubmit);
                $("form#" + formIDToSubmit).submit();
            }
    });
};

window.RefreshTable = function (tableId, urlData) {
    $.getJSON(urlData, null, function (json) {
        const table = $(tableId).dataTable();
        const oSettings = table.fnSettings();

        table.fnClearTable(this);

        for (var i = 0; i < json.aData.length; i++) {
            table.oApi._fnAddData(oSettings, json.aData[i]);
        }

        oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
        table.fnDraw();
    });
};

window.htmlEncode = function (value) {
    //create a in-memory div, set it's inner text(which jQuery automatically encodes)
    //then grab the encoded contents back out.  The div never exists on the page.
    return $('<div/>').text(value).html();
}

window.htmlDecode = function (value) {
    return $('<div/>').html(value).text();
}

window.tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
        , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    return function (table, name) {
        if (!table.nodeType) table = document.getElementById(table)
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML }
        window.open(uri + base64(format(template, ctx)));
    }
})();

window.Popup = function (data, title) {
    var mywindow = window.open('', 'my div', 'height=400,width=600');
    mywindow.document.write('<html><head><title>' + title + '</title>');
    mywindow.document.write('<style>* { color: #333 !important; } table { border:1px solid #DDD; border-collapse: collapse; } td, th { border: 1px solid #DDD; }</style>');
    mywindow.document.write('</head><body >');
    mywindow.document.write(data);
    mywindow.document.write('</body></html>');

    //mywindow.print();
    //mywindow.close();

    return true;
}

window.guid = (function () {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return function () {
        return s4() + s4() + '_' + s4() + '_' + s4() + '_' +
            s4() + '_' + s4() + s4() + s4();
    };
})();

window.createCookie = function (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}

window.readCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

window.eraseCookie = function (name) {
    createCookie(name, "", -1);
}

window.IsMobile = function () {
    // device detection
    var isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile/i).test(navigator.userAgent.toLowerCase());
    return isMobile;
}

window.LoadRequestForm = function (app, id, appName) {
    if (id == null || id == 0)
        return;
    $.ajax({
        url: "/legacy/Orders/GetPhysicianDetails",
        type: "GET",
        dataType: "json",
        async: false,
        data: {
            id: id
        },
        success: function (data) {
            if (app == 'App') {
                if (!$('#request #PatientHasInvitationWith').prop('checked')) {
                    $('#request #ReferringPhysician_UID').val(data.ID);
                    $('#request #ReferringPhysician_UID').attr('value', data.ID);
                    $('#request #ReferringPhysicianText').val(data.Text);
                    $('#request #ReferringPhysicianText').attr('value', data.Text);
                    $('#request #ReferringPhysician_RIZIV').val(data.Riziv);
                    $('#request #ReferringPhysician_RIZIV').attr('value', data.Riziv);
                    $('#request #ReferringPhysician_LastName').val(data.LastName);
                    $('#request #ReferringPhysician_LastName').attr('value', data.LastName);
                    $('#request #ReferringPhysician_FirstName').val(data.FirstName);
                    $('#request #ReferringPhysician_FirstName').attr('value', data.FirstName);
                }
            }
            if (app == 'AppCC') {
                $('#request #PhysicianCopy1_UID').val(data.ID);
                $('#request #PhysicianCopy1_UID').attr('value', data.ID);
                $('#request #PhysicianCopy1Text').val(data.Text);
                $('#request #PhysicianCopy1Text').attr('value', data.Text);
                $('#request #PhysicianCopy1_RIZIV').val(data.Riziv);
                $('#request #PhysicianCopy1_RIZIV').attr('value', data.Riziv);
                $('#request #PhysicianCopy1_LastName').val(data.LastName);
                $('#request #PhysicianCopy1_LastName').attr('value', data.LastName);
                $('#request #PhysicianCopy1_FirstName').val(data.FirstName);
                $('#request #PhysicianCopy1_FirstName').attr('value', data.FirstName);
            }
            if (app == 'AppCC2') {
                $('#request #PhysicianCopy2_UID').val(data.ID);
                $('#request #PhysicianCopy2_UID').attr('value', data.ID);
                $('#request #PhysicianCopy2Text').val(data.Text);
                $('#request #PhysicianCopy2Text').attr('value', data.Text);
                $('#request #PhysicianCopy2_RIZIV').val(data.Riziv);
                $('#request #PhysicianCopy2_RIZIV').attr('value', data.Riziv);
                $('#request #PhysicianCopy2_LastName').val(data.LastName);
                $('#request #PhysicianCopy2_LastName').attr('value', data.LastName);
                $('#request #PhysicianCopy2_FirstName').val(data.FirstName);
                $('#request #PhysicianCopy2_FirstName').attr('value', data.FirstName);
            }
        }
    });
}

window.setScanCookie = function (direction, cookieName) {
    let cookie = readCookie(cookieName);
    if (cookie == null || parseFloat(cookie) <= 0) {
        cookie = 1;
    }

    if (direction !== 0) {
        if (direction > 0) {
            cookie = parseFloat(cookie) + 0.1;
        }
        else {
            if (cookie > 0.2) {
                cookie = parseFloat(cookie) - 0.1;
            }
        }
    }

    setCookie(cookieName, cookie, 365);
}

window.resetScannedOrderZoom = function (cookieName) {
    setCookie(cookieName, 1, 365);
}

window.resize = function (element, cookieName) {
    let cookie = readCookie(cookieName);
    if (cookie == null || parseFloat(cookie) <= 0) {
        setScanCookie(0, cookieName);
        cookie = readCookie(cookieName);
    }
    if (cookie != null && element) {
        element.style.transformOrigin = "center center";
        //set scale to cookiesize!
        if ($(element).hasClass('d90')) {
            element.style.transform = "rotate(90deg) scale(" + cookie + ")";
        }
        else {
            if ($(element).hasClass('d180')) {
                if (parseFloat(cookie) > 1) {
                    let value = 50 + ((parseFloat(cookie).toFixed(1) - 1) * 20);
                    element.style.transformOrigin = value + "% " + value + "%";
                }
                element.style.transform = "rotate(180deg) scale(" + cookie + ")";
            }
            else {
                if ($(element).hasClass('d270')) {
                    element.style.transform = "rotate(270deg) scale(" + cookie + ")";
                }
                else {
                    element.style.transformOrigin = "0 0";
                    element.style.transform = "scale(" + cookie + ")";
                }
            }
        }
    }
}

window.isFunctionDefined = function (functionName) {
    return eval("typeof(" + functionName + ") == typeof(Function)");
}

window.handleLinktTypeCMD = function (CMDLink) {
    $.ajax({
        type: "POST",
        url: "/legacy/System/OpenCMDLink",
        async: true,
        data: {
            CMDLink: CMDLink
        },
    });
}

window.setAutocompleteInputLoading = function (isLoading, inputElement) {
    $(inputElement).toggleClass("loading", isLoading);
}

window.AddOrderProcedureToLock = function (orderProcedureUID) {
    return $.ajax({
        type: "POST",
        url: "/legacy/Locks/AddLock",
        data: {
            LockType: LockType.Report,
            RecordID: orderProcedureUID
        }
    });
};

window.setPhysicianAutocompleteResults = function (data, response) {
    let physicians = data.physicians;
    if (data.limitReached) {
        physicians.push({ FullText: data.limitReachedWarning, ID: -1 });
    }

    response($.map(physicians, function (item) {
        return {
            label: item.FullText,
            value: item.FullText,
            id: item.ID
        };
    }))
}

if (!Array.prototype.some) {
    Array.prototype.some = function (fun, thisArg) {
        'use strict';

        if (this == null) {
            throw new TypeError('Array.prototype.some called on null or undefined');
        }

        if (typeof fun !== 'function') {
            throw new TypeError();
        }

        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(thisArg, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

jQuery.fn.ForceNumericOnly = function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.charCode || e.keyCode || 0;
            if (key == 110 && $(this).val().indexOf('.') >= 0) {
                return false;
            }
            // allow backspace, tab, delete, arrows, numbers and keypad numbers ONLY
            // home, end, period, and numpad decimal
            return (
                key == 8 ||
                key == 9 ||
                key == 46 ||
                key == 190 ||
                key == 110 ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105) ||
                key == 13);
        });
    });
    //if (String.fromCharCode(e.keyCode).match(/[^0-9]/g)) return false;
};

jQuery.fn.ForcePositiveNegativeNumericOnly = function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.charCode || e.keyCode || 0;
            if (key == 110 && $(this).val().indexOf('.') >= 0) {
                return false;
            }
            if ((key == 109 || key == 189) && $(this).val().indexOf('-') >= 0) {
                return false;
            }
            // allow backspace, tab, delete, arrows, numbers and keypad numbers ONLY
            // home, end, period, and numpad decimal
            // dash and subtract
            return (
                key == 8 ||
                key == 9 ||
                key == 46 ||
                key == 190 ||
                key == 110 ||
                key == 109 ||
                key == 189 ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105) ||
                key == 13);
        });
    });
    //if (String.fromCharCode(e.keyCode).match(/[^0-9]/g)) return false;
};

jQuery.fn.ForceNumericWithoutPunctuation = function () {
    return this.each(function () {
        $(this).keydown(function (e) {
            var key = e.charCode || e.keyCode || 0;
            // allow backspace, tab, delete, arrows, numbers and keypad numbers ONLY
            // home, end, period, and numpad decimal
            return (
                key == 8 ||
                key == 9 ||
                key == 46 ||
                key == 190 ||
                (key >= 35 && key <= 40) ||
                (key >= 48 && key <= 57) ||
                (key >= 96 && key <= 105) ||
                key == 13);
        });
    });
    //if (String.fromCharCode(e.keyCode).match(/[^0-9]/g)) return false;
};

jQuery.fn.justtext = function () {
    return $(this).clone()
        .children()
        .remove()
        .end()
        .text();
};

// Disables the scrolling on ALL input number fields (RAD-3486)
$(document).on("wheel", "input[type=number]", function (e) {
    $(this).blur();
});

$('body').off('click', '.epdLink');
$('body').on('click', '.epdLink', function (e) {
    if ($(this).parent().find('.epdLinkType').val() == linkTypeCMD) {
        //cmd clicked
        e.preventDefault();
        e.stopImmediatePropagation();

        handleLinktTypeCMD($(this).attr('href'));
    }
});

$('body').off('click', '.unknownWordsFoundMessage');
$('body').on('click', '.unknownWordsFoundMessage', function (e) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    window.useFilingCabinet('/NewWords');
});
